module.exports = __webpack_public_path__ + "media/videoyellow.e9e31148.mp4";